import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'
class Table extends Component {
  render () {
    return (
      <div className={'Table ' + (this.props.className !== undefined ? this.props.className : '')}>
        {this.props.children}
      </div>
    )
  }
}
Table.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
}
export default Table
